import { Box, Typography, Container } from "@mui/material";

export default function Privacy() {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom sx={{ color: "#EC1C24", fontWeight: 'bold' }}>
          Privacy Policy
        </Typography>

        <Typography variant="body1" sx={{ textAlign: 'justify' }} paragraph>
          VEM Plus Urgent Care ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our facility or use our website, mobile application, or any other service provided by VEM Plus Urgent Care.

        </Typography>

        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          1. Information We Collect
        </Typography>
        <Typography variant="body2" sx={{  lineHeight: 1.2,fontWeight: 'bold' }} paragraph> A. Personal Information</Typography>
        <Typography variant="body2" mt={1} sx={{ textAlign: 'justify' }} paragraph>  Name, address, phone number, email address, Date of birth, gender, insurance information, Emergency contact details
        </Typography>


        <Typography variant="body2" sx={{ lineHeight: 1.2, fontWeight: 'bold' }} paragraph>B. Medical Information (Protected Health Information - PHI) </Typography>
        <Typography variant="body2" mt={1} sx={{ textAlign: 'justify' }} paragraph>
          Medical history and records, Diagnosis and treatment information, Prescription and lab results, Payment and billing data related to healthcare services.
        </Typography>

        <Typography variant="body2" sx={{ lineHeight: 1.2 , fontWeight: 'bold'}} paragraph>  C. Technical and Usage Data</Typography>
        <Typography variant="body2" mt={1} sx={{ textAlign: 'justify' }} paragraph>
          IP address, browser type, device type, Pages visited, time spent on our website ,Location information (if enabled on your device).
        </Typography>



        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          2. How We Use Your Information
        </Typography>

        <Typography variant="body2" sx={{ lineHeight: 1.8, textAlign: 'justify' }} paragraph>
          To provide medical treatment and care ,To communicate with you about your appointments, test results, and services ,To process insurance claims and billing, To maintain internal records and ensure regulatory compliance ,To improve our website and services, For marketing and health promotion (with your consent).
        </Typography>


        <Typography variant="body1" paragraph> </Typography>
        <Typography variant="body1" paragraph>

        </Typography>





        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          3. Sharing of Information
        </Typography>

        <Typography variant="body2" sx={{ lineHeight: 1.8 }} paragraph>We may share your information with:</Typography>
        <Typography variant="body2" mt={1} sx={{ lineHeight: 1.8, textAlign: 'justify' }} paragraph>
          Healthcare providers involved in your treatment
          , Insurance companies and billing services
          , Third-party service providers that help us operate our website or manage patient care (subject to strict confidentiality agreements)
          , Government or legal authorities as required by law or in response to valid legal process
          ,Your authorized representatives.
        </Typography>
        <Typography variant="caption" paragraph>
          We do not sell or rent your personal or health information to third parties.
        </Typography>



        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          4. Your Rights and Choices
        </Typography>

        <Typography variant="body2" sx={{ lineHeight: 1.8 }} paragraph>As a patient, you have the right to: </Typography>
        <Typography variant="body2" mt={1} sx={{ lineHeight: 1.8, textAlign: 'justify' }} paragraph>
          Access your medical records, Request corrections to your records,Request restrictions on certain uses/disclosures,Receive a list of disclosures we have made,File a complaint if you believe your privacy rights have been violated.
        </Typography>
        <Typography variant="caption" paragraph> To exercise these rights, please contact us using the information provided below. </Typography>


        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          5. Data Security
        </Typography>
        <Typography variant="body2" mt={1} sx={{ lineHeight: 1.8, textAlign: 'justify' }} paragraph>
          We implement appropriate physical, technical, and administrative safeguards to protect your information against unauthorized access, disclosure, or destruction.
        </Typography>
        <Typography variant="caption" paragraph> However, no data transmission or storage can be guaranteed to be 100% secure. You use our services at your own risk. </Typography>


        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          6. Cookies and Website Tracking
        </Typography>
        <Typography variant="body2" mt={1} sx={{ lineHeight: 1.8, textAlign: 'justify' }} paragraph>
          Our website may use cookies and similar technologies to enhance user experience, analyze traffic, and improve functionality. You may disable cookies in your browser settings.
        </Typography>

        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          7. Children’s Privacy
        </Typography>
        <Typography variant="body2" mt={1} sx={{ lineHeight: 1.8, textAlign: 'justify' }} paragraph>
          Our services are not intended for children under the age of 13 without parental or guardian consent. We do not knowingly collect personal information from minors unless required for medical treatment with appropriate consent.
        </Typography>

        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          8. Changes to This Policy
        </Typography>
        <Typography variant="body2" mt={1} sx={{ lineHeight: 1.8, textAlign: 'justify' }} paragraph>
          We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated “Effective Date.” We encourage you to review this policy periodically.

        </Typography>

        <Typography variant="h6" mt={4} sx={{ fontWeight: 'bold'}}>
          9. Contact Us
        </Typography>
        <Typography variant="body2" mt={1} sx={{ lineHeight: 1.8, textAlign: 'justify' }} paragraph>
          If you have any questions or concerns about this Privacy Policy or your personal information, please contact us:
        </Typography>
        <Typography variant="body2" mt={1} sx={{ lineHeight: 1.8, textAlign: 'justify', fontWeight: 'bold' }} paragraph>
          VEM Plus Urgent Care<br />

          Head Office- 73, Ground Floor, Emerald Plaza, 65 Gurgaon<br />


          Branch Office- Shop No-AFF20, 1st Floor, Signtaure Global The Millennia-1, Sector-37, Gurgaon<br />

          Phone: +91 9716467981<br />

          Email: amit.vishen@vemplusurgentcare.com<br />
        </Typography>


      </Container>
    </Box>
  );
}



